"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserProfile = UserProfile;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _UserBasicProfileForm = require("./UserBasicProfileForm");
var _UserEmailForm = require("./UserEmailForm");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function UserProfile() {
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    md: 10,
    lg: 8,
    xl: 6
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    rowSpacing: 6
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_UserBasicProfileForm.UserBasicProfileForm, null)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_UserEmailForm.UserEmailForm, null)))));
}